import { memo } from 'react';
import { Alert, Box, Snackbar } from '@mui/material';
import Main from 'components/Main/Main';
import useCapitalFlowHook from './hooks/useCapitalFlowHook';
import NovaCessao from './NovaCessao/NovaCessao';
import UploadCessao from './UploadCessao/UploadCessao';
import ContaCorrenteCessao from './ContaCorrenteCessao/ContaCorrenteCessao';
import './NovaCessao/NovaCessao.scss';

const CapitalFlow = ({ escopoAcesso, setEscopoAcesso }) => {
  const { openAlert, handleClose, carregarTela, setCarregarTela } = useCapitalFlowHook({
    escopoAcesso,
    setEscopoAcesso
  });

  return (
    <Main
      title="Dashboard"
      className="nova-sessao"
      escopoAcesso={escopoAcesso}
      setEscopoAcesso={setEscopoAcesso}
    >
      <Box className="dashboard">
        {carregarTela === 'NovaCessao' && (
          <NovaCessao
            setEscopoAcesso={setEscopoAcesso}
            escopoAcesso={escopoAcesso}
            setCarregarTela={setCarregarTela}
          />
        )}

        {carregarTela === 'UploadCessao' && (
          <UploadCessao
            setEscopoAcesso={setEscopoAcesso}
            escopoAcesso={escopoAcesso}
            setCarregarTela={setCarregarTela}
          />
        )}

        {carregarTela === 'ContaCorrenteCessao' && (
          <ContaCorrenteCessao
            setEscopoAcesso={setEscopoAcesso}
            escopoAcesso={escopoAcesso}
            setCarregarTela={setCarregarTela}
          />
        )}

        <Snackbar
          open={openAlert}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          onClose={handleClose}
        >
          <Alert onClose={handleClose} severity="warning">
            Você não tem permissão para acessar esta tela.
          </Alert>
        </Snackbar>
      </Box>
    </Main>
  );
};

export default memo(CapitalFlow);
